module.exports = __webpack_public_path__ + "img/166.7e839109.jpg";